module ProcessEditor {
    export function parameterEditorDirective(RecursionHelper: RecursionHelper): ng.IDirective {
        return {
            restrict: "EA",
            templateUrl: "parameterEditor.htm",
            scope: {
                parameters: "=",
                ctrl: "=",
                node: "="
            },
            compile: function (element) {
                // Use the compile function from the RecursionHelper,
                // And return the linking function(s) which it returns
                return RecursionHelper.compile(element, null);
            }
        }
    }

    app.directive("frendsParameterEditor", ["RecursionHelper", parameterEditorDirective]);


    export function arrayParameterEditorDirective(RecursionHelper: RecursionHelper): ng.IDirective {
        return {
            restrict: "EA",
            templateUrl: "arrayParameterEditor.htm",
            scope: {
                arrayParameter: "=",
                parameterTemplate: "=",
                ctrl: "=",
                node: "="
            },
            compile: function (element) {
                // Use the compile function from the RecursionHelper,
                // And return the linking function(s) which it returns
                return RecursionHelper.compile(element, (scope: IArrayParameterEditorScope, iElement, iAttrs) => {
                        scope.addParameter = () => {
                            scope.arrayParameter.subParameters.push(angular.copy(scope.parameterTemplate));
                            scope.ctrl.graphValidationService.markProcessDirty();
                        }

                        scope.removeParameter = (node: ITaskParameter) => {
                            const indexOfParameter = scope.arrayParameter.subParameters.indexOf(node);
                            scope.arrayParameter.subParameters.splice(indexOfParameter, 1);
                            scope.ctrl.graphValidationService.markProcessDirty();
                        }
                    }
                );
            }
        }
    }

    interface IArrayParameterEditorScope {
        arrayParameter: ITaskParameter,
        parameterTemplate: ITaskParameter,
        ctrl: ScopeEditorController,
        node: Node,

        addParameter();
        removeParameter(node: ITaskParameter);
    }

    app.directive("frendsArrayParameterEditor", ["RecursionHelper", arrayParameterEditorDirective]);

    export function emitShowOn(): ng.IDirective {
        return{
            restrict: "A",
            link(scope, element, attrs) {
                let event = attrs["frendsEmitShowOn"];
                element.on(event, (e) => {
                    scope.$emit("show.editor.frends");
                });
            }
        }
    }

    app.directive("frendsEmitShowOn", emitShowOn);

    export function ArrayParameterItemEditorDirective(): ng.IDirective {
        return {
            restrict: "EA",
            templateUrl: "arrayParameterItemEditor.htm",
            scope: {
                parameter: "=",
                ctrl: "=",
                node: "="
            }
        }
    }

    app.directive("frendsArrayParameterItemEditor", ArrayParameterItemEditorDirective);
}